var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import moment from 'moment';
import { isProcessBlockedDocument } from '@/utils/blocked-process-documents';
import { percentChange } from '@/utils/percentageChange';
import { privateHttp } from '../../helpers/Http';
import { generateUrl, parseSubject } from '../../helpers/Utils';
import { ITEMS_PER_PAGE } from '../../pages/app/consult/constants';
var urlBase = process.env.REACT_APP_API_BASE_URL;
var getAll = function (holderId, organizationId, params, isOpportunity) { return __awaiter(void 0, void 0, void 0, function () {
    var page, restParams, url, _a, result, total;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                page = params.page, restParams = __rest(params, ["page"]);
                url = generateUrl(urlBase, isOpportunity
                    ? "/v1/organization/".concat(organizationId, "/activities")
                    : "/v1/holder/".concat(holderId, "/organization/").concat(organizationId, "/activities"), __assign(__assign({}, restParams), { page: page ? page - 1 : 0 }));
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                _a = _b.sent(), result = _a.result, total = _a.total;
                return [2 /*return*/, {
                        items: result === null || result === void 0 ? void 0 : result.map(function (item) {
                            var _a;
                            var analyzes = (_a = item.userPlanConsumeAnalytics) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                                id: item.userPlanConsumeAnalyticsId,
                                date: item.createdAt,
                                type: item.typePlan,
                                status: item.statusIndex,
                            }); });
                            // Documentos bloqueados nao exibem contagem de processos na listagem
                            var isProcessBlocked = isProcessBlockedDocument(item.documentNumber);
                            return {
                                id: item.userPlanConsumeUniqueId,
                                name: item.documentInfo,
                                type: item.typeSearch,
                                document: item.documentNumber,
                                updatedAt: item.updatedAt,
                                total: isProcessBlocked ? 0 : item.consume,
                                enabledPause: item.accessPauseMonitor,
                                availablePauseDays: item.daypausemonitor,
                                availablePauseDate: item.dtAvailablePause,
                                analyzes: analyzes,
                                createdAt: item.createdAt,
                            };
                        }),
                        total: total,
                        limit: ITEMS_PER_PAGE,
                    }];
        }
    });
}); };
var getBalance = function (holderId, organizationId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, alerts, balances, balance;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = generateUrl(urlBase, "/v1/holder/".concat(holderId, "/organization/").concat(organizationId, "/balance"));
                alerts = [];
                balances = [];
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                balance = (_a.sent()).balance;
                alerts = balance.map(function (item) { return item.balance.msgConsume; }).filter(Boolean);
                balances = balance === null || balance === void 0 ? void 0 : balance.map(function (item) { return ({
                    id: item.balance.plan.planId,
                    type: item.balance.plan.typePlan,
                    remaining: item.balance.available,
                    consumed: item.balance.consume,
                    total: item.balance.plan.limitEnd,
                    isVisibled: item.balance.plan.isVisible,
                }); });
                return [2 /*return*/, { alerts: alerts, balances: balances }];
        }
    });
}); };
var putItem = function (holderId, organizationId, consumeUnique) {
    return privateHttp.put("".concat(urlBase, "/v1/holder/").concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeUnique, "/monitor"));
};
var deleteItem = function (holderId, organizationId, consumeUnique) {
    return privateHttp.delete("".concat(urlBase, "/v1/holder/").concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeUnique, "/monitor"));
};
var getAnalyze = function (holderId, organizationId, consumeId, analyzeId) { return __awaiter(void 0, void 0, Promise, function () {
    var register, summary, lastRegister;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, privateHttp.get("".concat(urlBase, "/v1/holder/").concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeId, "/analytics/").concat(analyzeId))];
            case 1:
                register = (_a.sent()).register;
                summary = {
                    all: {
                        totalProcess: register.summary.ALL.totalProcess,
                        totalValue: Number(register.summary.ALL.vltotalProcess),
                    },
                    criminal: {
                        totalProcess: register.summary.RISK_CRIMINAL.totalProcess,
                        totalValue: Number(register.summary.RISK_CRIMINAL.vltotalProcess),
                    },
                    execution: {
                        totalProcess: register.summary.RISK_EXECUTION.totalProcess,
                        totalValue: Number(register.summary.RISK_EXECUTION.vltotalProcess),
                    },
                    worker: {
                        totalProcess: register.summary.RISK_WORKER.totalProcess,
                        totalValue: Number(register.summary.RISK_WORKER.vltotalProcess),
                    },
                    litigation: {
                        totalProcess: register.summary.LITIGATION.totalProcess,
                        totalValue: Number(register.summary.LITIGATION.vltotalProcess),
                    },
                    author: {
                        totalProcess: register.summary.ISAUTHOR.totalProcess,
                        totalValue: Number(register.summary.ISAUTHOR.vltotalProcess),
                    },
                    defendant: {
                        totalProcess: register.summary.ISDEFENDANT.totalProcess,
                        totalValue: Number(register.summary.ISDEFENDANT.vltotalProcess),
                    },
                };
                if (!register.lastUserPlanConsumeAnalytics) return [3 /*break*/, 3];
                return [4 /*yield*/, privateHttp.get("".concat(urlBase, "/v1/holder/").concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeId, "/analytics/").concat(register.lastUserPlanConsumeAnalytics))];
            case 2:
                lastRegister = (_a.sent()).register;
                summary = __assign(__assign({}, summary), { criminal: __assign(__assign({}, summary.criminal), { percentageValueChange: percentChange(Number(register.summary.RISK_CRIMINAL.vltotalProcess), Number(lastRegister.summary.RISK_CRIMINAL.vltotalProcess)) }), execution: __assign(__assign({}, summary.execution), { percentageValueChange: percentChange(Number(register.summary.RISK_EXECUTION.vltotalProcess), Number(lastRegister.summary.RISK_EXECUTION.vltotalProcess)) }), worker: __assign(__assign({}, summary.worker), { percentageValueChange: percentChange(Number(register.summary.RISK_WORKER.vltotalProcess), Number(lastRegister.summary.RISK_WORKER.vltotalProcess)) }) });
                _a.label = 3;
            case 3: return [2 /*return*/, {
                    type: register.typePlan,
                    status: register.statusIndex,
                    statusReport: register.statusReport,
                    file: {
                        url: register.urlTemp,
                        urlFull: register.urlTempFull,
                    },
                    totalProcessAnalyzed: register.summary.ALL.totalProcess,
                    lastAnalyzedId: register.lastUserPlanConsumeAnalytics,
                    summary: summary,
                }];
        }
    });
}); };
var getTypeOfPart = function (isAuthor, isDefendant) {
    if (isAuthor)
        return 'AUTOR';
    if (isDefendant)
        return 'DEFENDANT';
    return undefined;
};
// const getAnalyzeMetric = async (
//   holderId: number,
//   organizationId: number,
//   consumeId: number,
//   analyzeId: number
// ) => {
//   const url = generateUrl(
//     urlBase,
//     `/v1/holder/${holderId}/organization/${organizationId}/consumeunique/${consumeId}/analytics/${analyzeId}/metric`
//   );
//   const { register }: any = await privateHttp.get(url);
//   return {
//     // year: {
//     //   avg: '',
//     //   history: register.aggsSumYear.reverse().map((item: any) => ({
//     //     label: item.aggs,
//     //     total: item.count,
//     //     amount: item.sum / 100,
//     //   })),
//     // },
//     year: {
//       ...register.aggsSumYear.reverse().reduce(
//         (acc: any, curr: any, currIndex: number, array: any) => {
//           const amount = curr.sum / 100;
//           return {
//             avg: acc.avg + amount / array.length,
//             history: [
//               ...acc.history,
//               {
//                 label: moment(curr.aggs, 'YYYYMM').format('MM/YYYY'),
//                 total: curr.count,
//                 amount,
//               },
//             ],
//           };
//         },
//         {
//           avg: 0,
//           history: [],
//         }
//       ),
//     },
//     month: {
//       ...register.aggsSumYearMonth.reverse().reduce(
//         (acc: any, curr: any, currIndex: number, array: any) => {
//           const amount = curr.sum / 100;
//           return {
//             avg: acc.amount + amount / array.length,
//             history: [
//               ...acc.history,
//               {
//                 label: moment(curr.aggs, 'YYYYMM').format('MM/YYYY'),
//                 total: curr.count,
//                 amount,
//               },
//             ],
//           };
//         },
//         {
//           avg: 0,
//           history: [],
//         }
//       ),
//     },
//   };
// };
/**
 * getAnalyzeDetailed
 * ! Deprecated method
 */
var getAnalyzeDetailed = function (holderId, organizationId, consumeId, analyzeId, params) { return __awaiter(void 0, void 0, Promise, function () {
    var page, restParams, url, register, totalActive, totalInactive, totalValueActive, totalValueInactive, totalAuthor, totalValueAuthor, totalDefendant, totalValueDefendant, total, amount, typeData;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                page = params.page, restParams = __rest(params, ["page"]);
                url = generateUrl(urlBase, "/v1/holder/".concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeId, "/analytics/").concat(analyzeId, "/detail"), __assign({ from: (page - 1) * 10, size: 10 }, restParams));
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                register = (_b.sent()).register;
                totalActive = register["totalProcess_".concat(params.typeRisk)] || 0;
                totalInactive = register["totalProcess_".concat(params.typeRisk, "_SECUNDARY")] || 0;
                totalValueActive = Number(register["vltotalProcess_".concat(params.typeRisk)]) || 0;
                totalValueInactive = Number(register["vltotalProcess_".concat(params.typeRisk, "_SECUNDARY")] || 0);
                totalAuthor = register.totalProcess_ISAUTHOR_WITH_RISK || 0;
                totalValueAuthor = register.vltotalProcess_ISAUTHOR_WITH_RISK || 0;
                totalDefendant = register.totalProcess_ISDEFENDANT_WITH_RISK || 0;
                totalValueDefendant = register.vltotalProcess_ISDEFENDANT_WITH_RISK || 0;
                total = 0;
                amount = 0;
                typeData = 'ALL';
                if (params.typeRisk === 'RISK_EXECUTION' ||
                    params.typeRisk === 'LITIGATION' ||
                    (params.typeRisk === 'RISK_WORKER' && params.documentType === 'CNPJ')) {
                    typeData = 'ACTIVE';
                    total = totalActive;
                    amount = totalValueActive;
                }
                if (params.typeRisk === 'RISK_CRIMINAL' ||
                    (params.typeRisk === 'RISK_WORKER' && params.documentType === 'CPF')) {
                    total = totalActive + totalInactive;
                    amount = totalValueActive + totalValueInactive;
                }
                if (params.typeRisk === 'LITIGATION') {
                    totalAuthor = register.totalProcess_ISAUTHOR || 0;
                    totalValueAuthor = register.vltotalProcess_ISAUTHOR || 0;
                    totalDefendant = register.totalProcess_ISDEFENDANT || 0;
                    totalValueDefendant = register.vltotalProcess_ISDEFENDANT || 0;
                }
                return [2 /*return*/, {
                        typeData: typeData,
                        totalProcesses: total,
                        totalActiveProcesses: totalActive,
                        totalInactiveProcesses: totalInactive,
                        totalAuthor: totalAuthor,
                        totalDefendant: totalDefendant,
                        // amount: Number(register.vltotalProcess),
                        amount: amount,
                        amountActives: totalValueActive,
                        amountInactives: totalValueInactive,
                        amountAuthor: totalValueAuthor,
                        amountDefendant: totalValueDefendant,
                        processes: (_a = register.docs) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                            number: item.process,
                            distributionDate: item.content.dataDistribuicao,
                            causeValue: item.value_claim,
                            uf: item.content.uf,
                            court: item.content.court,
                            subjects: parseSubject(item.content.assunto || ''),
                            isArchived: item.archived,
                            typeOfPart: getTypeOfPart(item.process_is_author, item.process_is_defendant),
                        }); }),
                    }];
        }
    });
}); };
var getAnalyzeDetailedMetric = function (holderId, organizationId, consumeId, analyzeId, params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, urlActive, urlInactive, _a, metric, metricActive, metricInactive, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                url = generateUrl(urlBase, "/v1/holder/".concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeId, "/analytics/").concat(analyzeId, "/metric"), {
                    typeRisk: params.typeRisk,
                });
                urlActive = generateUrl(urlBase, "/v1/holder/".concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeId, "/analytics/").concat(analyzeId, "/metric"), {
                    typeRisk: params.typeRisk,
                    active: true,
                });
                urlInactive = generateUrl(urlBase, "/v1/holder/".concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeId, "/analytics/").concat(analyzeId, "/metric"), {
                    typeRisk: params.typeRisk,
                    active: 'false',
                });
                _c = (_b = Promise).all;
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                _d = [
                    _e.sent()
                ];
                return [4 /*yield*/, privateHttp.get(urlActive)];
            case 2:
                _d = _d.concat([
                    _e.sent()
                ]);
                return [4 /*yield*/, privateHttp.get(urlInactive)];
            case 3: return [4 /*yield*/, _c.apply(_b, [_d.concat([
                        _e.sent()
                    ])])];
            case 4:
                _a = _e.sent(), metric = _a[0], metricActive = _a[1], metricInactive = _a[2];
                return [2 /*return*/, {
                        year: metric.register.aggsSumYear.reverse().map(function (item) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                            return {
                                label: item.aggs,
                                total: item.count,
                                amount: item.sum / 100,
                                active: {
                                    total: ((_c = (_b = (_a = metricActive.register) === null || _a === void 0 ? void 0 : _a.aggsSumYear) === null || _b === void 0 ? void 0 : _b.find(function (findItem) { return findItem.aggs === item.aggs; })) === null || _c === void 0 ? void 0 : _c.count) || 0,
                                    amount: ((_f = (_e = (_d = metricActive.register) === null || _d === void 0 ? void 0 : _d.aggsSumYear) === null || _e === void 0 ? void 0 : _e.find(function (findItem) { return findItem.aggs === item.aggs; })) === null || _f === void 0 ? void 0 : _f.sum) / 100 || 0,
                                },
                                inactive: {
                                    total: ((_j = (_h = (_g = metricInactive.register) === null || _g === void 0 ? void 0 : _g.aggsSumYear) === null || _h === void 0 ? void 0 : _h.find(function (findItem) { return findItem.aggs === item.aggs; })) === null || _j === void 0 ? void 0 : _j.count) || 0,
                                    amount: ((_m = (_l = (_k = metricInactive.register) === null || _k === void 0 ? void 0 : _k.aggsSumYear) === null || _l === void 0 ? void 0 : _l.find(function (findItem) { return findItem.aggs === item.aggs; })) === null || _m === void 0 ? void 0 : _m.sum) / 100 || 0,
                                },
                            };
                        }),
                        month: metricActive.register.aggsSumYearMonth
                            .reverse()
                            .map(function (item) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                            return ({
                                label: moment(item.aggs, 'YYYYMM').format('MM/YYYY'),
                                total: item.count,
                                amount: item.sum / 100,
                                active: {
                                    total: ((_c = (_b = (_a = metricActive.register) === null || _a === void 0 ? void 0 : _a.aggsSumYear) === null || _b === void 0 ? void 0 : _b.find(function (findItem) { return findItem.aggs === item.aggs; })) === null || _c === void 0 ? void 0 : _c.count) || 0,
                                    amount: ((_f = (_e = (_d = metricActive.register) === null || _d === void 0 ? void 0 : _d.aggsSumYear) === null || _e === void 0 ? void 0 : _e.find(function (findItem) { return findItem.aggs === item.aggs; })) === null || _f === void 0 ? void 0 : _f.sum) / 100 || 0,
                                },
                                inactive: {
                                    total: ((_j = (_h = (_g = metricInactive.register) === null || _g === void 0 ? void 0 : _g.aggsSumYear) === null || _h === void 0 ? void 0 : _h.find(function (findItem) { return findItem.aggs === item.aggs; })) === null || _j === void 0 ? void 0 : _j.count) || 0,
                                    amount: ((_m = (_l = (_k = metricInactive.register) === null || _k === void 0 ? void 0 : _k.aggsSumYear) === null || _l === void 0 ? void 0 : _l.find(function (findItem) { return findItem.aggs === item.aggs; })) === null || _m === void 0 ? void 0 : _m.sum) / 100 || 0,
                                },
                            });
                        }),
                    }];
        }
    });
}); };
var analyze = function (holderId, organizationId, consumeId, planId) { return __awaiter(void 0, void 0, void 0, function () {
    var register;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, privateHttp.put("".concat(urlBase, "/v1/holder/").concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeId, "/plan/").concat(planId, "/analytics"))];
            case 1:
                register = (_a.sent()).register;
                return [2 /*return*/, {
                        id: register.userPlanConsumeAnalyticsId,
                    }];
        }
    });
}); };
var getHolderMetrics = function (holderId, organizationId, data) { return __awaiter(void 0, void 0, Promise, function () {
    var _a, aggsSearchConsumeAll, aggsMonitorConsume, aggsPauseConsume, aggsAnalyzerBasicConsume, aggsAnalyzerPremiumConsume, aggsCompetence, aggsOrganization;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, privateHttp.post("".concat(urlBase, "/v1/holder/").concat(holderId, "/organization/").concat(organizationId, "/metricconsume"), data
                    ? {
                        competence: data.month,
                        organizationId: data.organizationId,
                    }
                    : undefined)];
            case 1:
                _a = _b.sent(), aggsSearchConsumeAll = _a.aggsSearchConsumeAll, aggsMonitorConsume = _a.aggsMonitorConsume, aggsPauseConsume = _a.aggsPauseConsume, aggsAnalyzerBasicConsume = _a.aggsAnalyzerBasicConsume, aggsAnalyzerPremiumConsume = _a.aggsAnalyzerPremiumConsume, aggsCompetence = _a.aggsCompetence, aggsOrganization = _a.aggsOrganization;
                return [2 /*return*/, {
                        consulted: aggsSearchConsumeAll,
                        monitoring: {
                            total: aggsMonitorConsume,
                            paused: aggsPauseConsume,
                        },
                        analysis: {
                            total: aggsAnalyzerBasicConsume + aggsAnalyzerPremiumConsume,
                            basic: aggsAnalyzerBasicConsume,
                            premium: aggsAnalyzerPremiumConsume,
                        },
                        totalByMonths: (aggsCompetence === null || aggsCompetence === void 0 ? void 0 : aggsCompetence.reduce(function (acc, curr) {
                            var _a;
                            var args = (_a = curr.aggsOrganization) === null || _a === void 0 ? void 0 : _a.reduce(function (argAcc, argCurr) {
                                var analized = argAcc.analized || 0;
                                var monitored = argAcc.monitored || 0;
                                var consulted = argAcc.consulted || 0;
                                var paused = argAcc.paused || 0;
                                return {
                                    consulted: consulted + argCurr.aggsSearchConsumeAll.value,
                                    monitored: monitored + argCurr.aggsMonitorConsume.value,
                                    paused: paused + argCurr.aggsPauseConsume.value,
                                    analized: analized +
                                        (argCurr.aggsAnalyzerBasicConsume.value +
                                            argCurr.aggsAnalyzerPremiumConsume.value),
                                };
                            }, {});
                            acc[curr.key] = args;
                            return acc;
                        }, {})) || {
                            consulted: 0,
                            monitores: 0,
                            paused: 0,
                            analized: 0,
                        },
                        organizations: (aggsOrganization === null || aggsOrganization === void 0 ? void 0 : aggsOrganization
                        // .filter(
                        //   (organization: any) =>
                        //     organization.organization.typeOrganization !== 'MASTER'
                        // )
                        .map(function (organization) { return ({
                            id: organization.organization.organizationId,
                            name: organization.organization.organizationName,
                            consulted: organization.aggsSearchConsumeAll.value,
                            monitored: organization.aggsMonitorConsume.value,
                            paused: organization.aggsPauseConsume.value,
                            analized: organization.aggsAnalyzerBasicConsume.value +
                                organization.aggsAnalyzerPremiumConsume.value,
                        }); })) || [],
                    }];
        }
    });
}); };
export var ConsultService = {
    getAll: getAll,
    getBalance: getBalance,
    putItem: putItem,
    deleteItem: deleteItem,
    getAnalyze: getAnalyze,
    // getAnalyzeMetric,
    getAnalyzeDetailed: getAnalyzeDetailed,
    getAnalyzeDetailedMetric: getAnalyzeDetailedMetric,
    analyze: analyze,
    getHolderMetrics: getHolderMetrics,
};
